import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { ButtonData_Type, Link_Target } from 'ricos-schema';
import { LinkPanelWrapper } from 'wix-rich-content-toolbars-modals';
import { TextInput } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { BUTTON_INPUT_MODAL } from '../dataHooks.js';

var css_248z = "._86wX8,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.w-ldL{color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;font-weight:400;height:22px;line-height:1.5}[dir] .w-ldL{margin:7px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.w-ldL{font-weight:400}[dir] .w-ldL{margin:4px 0 0}}}@container (width < 640px){.w-ldL{font-weight:400}[dir] .w-ldL{margin:4px 0 0}}.W-bZe{font-size:14px;font-weight:400;height:22px;line-height:1.5}[dir] .W-bZe{margin:9px 0 7px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.W-bZe{font-weight:400}[dir] .W-bZe{margin:2px 0 1px}}}@container (width < 640px){.W-bZe{font-weight:400}[dir] .W-bZe{margin:2px 0 1px}}[dir] ._6z8z0{margin-top:6px}[dir=ltr] ._6z8z0{margin-left:0}[dir=rtl] ._6z8z0{margin-right:0}.ueRXw{color:#ee5951;font-size:12px}[dir] .ueRXw{padding-top:7px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.ueRXw{line-height:1.5;width:213px}[dir] .ueRXw{padding-top:18px}[dir=ltr] .ueRXw{margin-left:1px}[dir=rtl] .ueRXw{margin-right:1px}}}@container (width < 640px){.ueRXw{line-height:1.5;width:213px}[dir] .ueRXw{padding-top:18px}[dir=ltr] .ueRXw{margin-left:1px}[dir=rtl] .ueRXw{margin-right:1px}}[dir] .XgELz{padding-top:13px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .XgELz{padding-bottom:1px;padding-top:22px}}}@container (width < 640px){[dir] .XgELz{padding-bottom:1px;padding-top:22px}}.sDz0s{outline:none}[dir] .sDz0s{margin-bottom:15px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .sDz0s{margin-bottom:22px}}}@container (width < 640px){[dir] .sDz0s{margin-bottom:22px}}[dir] .cpDtA{padding:30px 0}[dir] .-DNQs{padding-bottom:8px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .-DNQs{padding-bottom:28px}}}@container (width < 640px){[dir] .-DNQs{padding-bottom:28px}}[dir] .lK6A3{padding:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .lK6A3{padding-top:16px}[dir=ltr] .lK6A3{padding-right:0}[dir=rtl] .lK6A3{padding-left:0}}}@container (width < 640px){[dir] .lK6A3{padding-top:16px}[dir=ltr] .lK6A3{padding-right:0}[dir=rtl] .lK6A3{padding-left:0}}.LdSWR{height:18px;width:18px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LdSWR{top:-6px}[dir=ltr] .LdSWR{right:0}[dir=rtl] .LdSWR{left:0}}}@container (width < 640px){.LdSWR{top:-6px}[dir=ltr] .LdSWR{right:0}[dir=rtl] .LdSWR{left:0}}.RXOY1{font-size:16px}[dir] .RXOY1{border-radius:0;padding-bottom:1px}[dir=ltr] .RXOY1{padding-left:17px}[dir=rtl] .RXOY1{padding-right:17px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.RXOY1{font-size:16px}[dir] .RXOY1{border-radius:0;margin-top:7px;padding-top:3px}}}@container (width < 640px){.RXOY1{font-size:16px}[dir] .RXOY1{border-radius:0;margin-top:7px;padding-top:3px}}.RXOY1::placeholder{color:var(--ricos-settings-text-color,#333);font-size:14px}[dir] .sDz0s:hover .C8oMg{background-color:#fff}._0qcIq{display:inherit}.BWJua:hover .C8oMg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .BWJua:hover .C8oMg{background-color:#fff}[dir] .UsxpE{padding-top:2px}[dir] ._8bVj8{background-color:#fff;border:1px solid #000;border-radius:1px}._8bVj8:hover{color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.O7qWf{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .O7qWf{background-color:#fff}.pdgM-{font-size:16px}[dir=ltr] .pdgM-{margin-left:20px}[dir=rtl] .pdgM-{margin-right:20px}";
var styles = {"fontElementMap":"_86wX8","button_settingsComponent_header_ButtonText":"w-ldL","button_settingsComponent_header_ButtonLink":"W-bZe","settingTab":"_6z8z0","button_settingsComponent_errorMessage":"ueRXw","button_settingsComponent_checkBoxes":"XgELz","checkbox":"sDz0s","modal_footer":"cpDtA","button_settingsComponent_name_feild":"-DNQs","button_settingsComponent_section_content":"lK6A3","textInput_errorIcon":"LdSWR","textInput_input":"RXOY1","checkbox_icon_unchecked":"C8oMg","checkbox_wrapper":"_0qcIq","checkbox_inputLabel":"BWJua","checkbox_infoIcon":"UsxpE","checkbox_icon":"_8bVj8","checkbox_icon_checked":"O7qWf","checkbox_label":"pdgM-"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SettingsComponent = ({
  buttonData,
  onKeyPress,
  onChange
}) => {
  var _a, _b, _c;
  const { t } = useContext(RicosContext);
  const toTarget = (target) => {
    switch (target) {
      case "_top":
        return Link_Target.TOP;
      case "_blank":
        return Link_Target.BLANK;
      default:
        return Link_Target.TOP;
    }
  };
  const toRel = (rel) => {
    return {
      nofollow: rel.includes("nofollow"),
      sponsored: rel.includes("sponsored")
    };
  };
  const fromRel = (linkRel) => {
    if (!linkRel) {
      return "";
    }
    const relValues = [];
    if (linkRel.nofollow)
      relValues.push("nofollow");
    if (linkRel.sponsored)
      relValues.push("sponsored");
    return relValues.join(" ");
  };
  return /* @__PURE__ */ React.createElement("div", { className: styles.button_settingsComponent_section_content }, /* @__PURE__ */ React.createElement("div", { className: styles.button_settingsComponent_name_feild }, /* @__PURE__ */ React.createElement("div", { className: styles.button_settingsComponent_header_ButtonText }, t("ButtonModal_Button_Text")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    TextInput,
    {
      type: "text",
      onChange: (text) => onChange(__spreadProps(__spreadValues({}, buttonData), { text })),
      value: buttonData.text,
      inputDataHook: BUTTON_INPUT_MODAL,
      onKeyPress,
      placeholder: t("ButtonModal_InputName_Placeholder")
    }
  ))), buttonData.type === ButtonData_Type.LINK && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.button_settingsComponent_header_ButtonLink }, t("ButtonModal_Button_Link")), /* @__PURE__ */ React.createElement(
    LinkPanelWrapper,
    {
      linkValues: {
        url: (_a = buttonData.link) == null ? void 0 : _a.url,
        target: `_${(_b = buttonData.link) == null ? void 0 : _b.target.toLowerCase()}`,
        rel: fromRel((_c = buttonData.link) == null ? void 0 : _c.rel)
      },
      onChange: (data) => {
        onChange(__spreadProps(__spreadValues({}, buttonData), {
          link: __spreadProps(__spreadValues({
            anchor: void 0
          }, buttonData == null ? void 0 : buttonData.link), {
            url: data.url,
            target: toTarget(data.target),
            rel: toRel(data.rel)
          })
        }));
      },
      options: {
        showNewTabCheckbox: true,
        showNoFollowCheckbox: true,
        showNoReferrerCheckbox: false,
        showSponsoredCheckbox: true
      },
      t
    }
  )));
};

export { SettingsComponent };
//# sourceMappingURL=settings-component.js.map
